import { FC } from "react"
import { Select } from "../Select"
import closeIcon from "../../../assets/fonts/closeBlack.svg"
import "./styles.scss"
import { Box, TextField } from "@mui/material"
import { PHONE_TYPES } from "../../../constants/CreateHousehold"
import { useTranslation } from "../../../hooks/useTranslation"
import { useContactEnumLabel } from "../../../utils/contactEnumDisplay"
import { cleanPhone } from "../../../utils/phoneNumber"
import { usePhoneValidation } from "../../../hooks/usePhoneValidation"

type Props = {
  label: string
  value: string
  firstEndIcon?: string
  secondEndIcon?: string
  type: string
  index: string
  onChange: (value: string, type: string, index: string) => void;
  onTypeChange: (type: string, index: string) => void;
  onDeletePhone: (index: number) => void;
  isRequired?: boolean
  /** Hide the Mobile/Home/Work/Other selector (fixed-type slots like Cell / Work). */
  hideTypeSelect?: boolean
  /** Hide the delete (×) control (fixed slots are cleared by emptying the field). */
  hideDelete?: boolean
  /** When set, show a clear (×) icon inside the field (right) while it has a value;
   *  clicking it clears the field. Used by the contact editor's fixed Cell/Work slots. */
  onClear?: () => void
  /** True once a submit has been blocked, so an untouched bad value (e.g. one loaded
   *  from the database while editing) is marked instead of failing silently. */
  submitAttempted?: boolean
}

/**
 * Plain text field, stripped as you type and checked loosely on blur — no country or prefix
 * handling of any kind. See CreateHouseholdPage/PhoneNumberInput.
 */
export const PhoneNumberInputWithType: FC<Props> = ({
  label,
  value,
  type,
  index,
  onChange,
  onTypeChange,
  onDeletePhone,
  isRequired,
  hideTypeSelect,
  hideDelete,
  onClear,
  submitAttempted
}) => {
  const phoneTypesOptions = PHONE_TYPES

  const { p, t } = useTranslation('contact_info');
  const enumLabel = useContactEnumLabel();
  const { isError, helperText, onBlur, onEdit } = usePhoneValidation(value, submitAttempted)
  return (
    <Box
      sx={{
        flexDirection: { md: "row", xs: "column" }
      }}
      className="phone-number-container"
    >
      {!hideTypeSelect && (
        <Box
          sx={{
            width: { md: "auto", xs: "100%" }
          }}
          className="phone-number-input-with-type__type-container"
        >
          <Select
            onChangeClose
            label={p('type')}
            list={phoneTypesOptions}
            getOptionLabel={enumLabel}
            value={type}
            placeholder={p('select')}
            handleSelect={(value) => onTypeChange(value, index)}
          />
        </Box>
      )}

      <div className="phone-number-block__container">
        <div className="phone-number-input-with-type__input-container">
          <label className="phone-number-input-with-type__label">{label}{isRequired && <span style={{ color: "red" }}>*</span>}</label>
          {/* <div className="phone-number-input-with-type__end-icon-container">
            {firstEndIcon && (
              <label className="phone-number-input-with-type__end-icon">
                <a href={`tel:${value}`}>
                  <img src={firstEndIcon} alt="end-icon" />
                </a>
              </label>
            )}
            {secondEndIcon && type === 'Mobile' && (
              <label className="phone-number-input-with-type__end-icon">
                <img src={secondEndIcon} alt="end-icon" />
              </label>
            )}
            
          </div> */}
          {/* Edit mode shows the field only — the call/SMS action icons live in the
              display view (ContactInfoModal). The optional clear (×) sits where that
              action icon used to be, so the field width is unchanged. */}
          {onClear && value && value.trim() !== "" && (
            <label
              className="phone-number-input-with-type__end-icon-container"
              onClick={onClear}
              title={t("general.delete")}
              style={{ cursor: "pointer" }}
            >
              <img src={closeIcon} alt="clear" width={15} height={15} />
            </label>
          )}
          <TextField
            className="phone-number-input-with-type__tel"
            type="tel"
            inputProps={{ inputMode: "tel", autoComplete: "tel" }}
            fullWidth
            error={isError}
            helperText={helperText}
            value={value ?? ""}
            onBlur={onBlur}
            onChange={(e) => {
              onEdit()
              onChange(cleanPhone(e.target.value), type, index)
            }}
          />
        </div>
        {!hideDelete && (
          <label
            className="phone-number-input-with-type__delete-icon"
            onClick={() => onDeletePhone(Number(index))}
          >
            <img src={closeIcon} alt="delete-icon" />
          </label>
        )}
        {/* <div className="phone-number-input-with-type__absolute-number">+44</div> */}
      </div>
    </Box>
  )
}
